import { Injectable, inject } from '@angular/core'
import { THEME } from '../enums/theme.enum'
import { LocalStorageService } from './local-storage.service'
import { Observable, of } from 'rxjs'
import { CoreService } from './core.service'

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  protected ls = inject(LocalStorageService)
  protected coreService = inject(CoreService)

  get theme(): THEME {
    return this.ls.getItem('theme') || THEME.WHITE
  }

  init(): Observable<void> {
    return of(this.setTheme(this.theme))
  }

  setTheme(theme: THEME) {
    if (this.coreService.isBrowser()) {
      this.ls.setItem('theme', theme)
      document.body.classList.add(theme)
      document.body.classList.remove(theme === THEME.WHITE ? THEME.DARK : THEME.WHITE)
    }
  }
}
